module.exports = __webpack_public_path__ + "static/botshirt-c2629bea7d6b49b88a17fed688822b23.png";